import { propertyDetailsConditionalFields } from '@modules/_shared/components/property-form/forms-definitions/propertyDetailsFormDefinition';
import type { PropertyTypeLight } from '@modules/_shared/components/property-form/propertyFormQueries';

export const TRANSACTION_PROPERTY_DETAIL_FIELDS = [
  'number_of_rooms',
  'number_of_bedrooms',
  'living_surface',
  'built_surface',
  'usable_surface',
  'land_surface',
] as const;

export type TransactionPropertyDetailField =
  (typeof TRANSACTION_PROPERTY_DETAIL_FIELDS)[number];

export const isTransactionPropertyDetailFieldVisible = (
  propertyType: PropertyTypeLight | undefined,
  field: TransactionPropertyDetailField,
): boolean =>
  propertyType != null &&
  (propertyDetailsConditionalFields.get(field)?.(
    {
      __main_type: propertyType.main_type,
      __property_type: propertyType,
    },
    { isTransaction: true },
  ) ??
    false);

export const getInvalidTransactionPropertyDetailFields = (
  propertyType: PropertyTypeLight | undefined,
): TransactionPropertyDetailField[] =>
  TRANSACTION_PROPERTY_DETAIL_FIELDS.filter(
    field => !isTransactionPropertyDetailFieldVisible(propertyType, field),
  );

export const clearInvalidTransactionPropertyDetailFields = (
  propertyType: PropertyTypeLight | undefined,
  clearField: (field: TransactionPropertyDetailField) => void,
): void => {
  for (const field of getInvalidTransactionPropertyDetailFields(propertyType)) {
    clearField(field);
  }
};
